import { useTranslatedText } from '@/hooks/useTranslation';
import { forwardRef } from 'react';

interface TranslatedTextProps {
  children: string;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  [key: string]: any;
}

const TranslatedText = forwardRef<HTMLElement, TranslatedTextProps>(
  ({ children, as: Component = 'span', className, ...props }, ref) => {
    const translatedText = useTranslatedText(children);

    return (
      <Component ref={ref as never} className={className} {...props}>
        {translatedText}
      </Component>
    );
  }
);

TranslatedText.displayName = 'TranslatedText';

export default TranslatedText;